import '../../vendor/cookieconsent.css';
import '../../vendor/font-awesome.css';
import '../../vendor/slick.css';
import '../../vendor/slick-theme.css';
import '../../vendor/slick-lightbox.css';
import '../../vendor/plyr.css';

import '../../../Web/css/rte.css';
import '../css/components.css';
import '../css/mega-menu.css';
import '../css/main-style.css';
import '../css/slider.css';
import '../css/media-queries.css';
import '../css/editors-style.css';
import '../css/mobile_menu.css';

import '../sass/contact.scss';
import '../sass/suggest-lang.scss';

import clickDiv              from "components/click-div";
import {dropdown}            from "components/dropdown";
import globalLanguageMenu    from "components/global-language-menu";
import signUpNewsletterForm2 from "components/sign-up-newsletter-form-2";
import signUpNewsletterForm3 from "components/sign-up-newsletter-form-3";
import videoPlayer           from "components/video";
import svgCheckBox           from "vendor/svgcheckbx";
import contact from 'components/contact';
import quote from 'components/quote';
import suggestPopLanguage from "components/suggest-pop-lang";

$(() => {
  clickDiv();
  dropdown();

  globalLanguageMenu();
  svgCheckBox();
  signUpNewsletterForm2();
  signUpNewsletterForm3();
  contact();
  videoPlayer();
  quote();
  suggestPopLanguage();
});
